export const HOLIDAYS_ENDPOINTS = {
  featuredJourney: "/api/Holiday/FeaturedJourneys",
  unlockParadise: "/api/Holiday/GetParadises",
  home: "/api/Holiday/GetHome",
  list: "/api/Holiday/GetHolidaysList",
  detailsBySlug: "/api/Holiday/GetHolidaysDetailsBySlug",
  packages: "/api/Holiday/GetPackages",
  packageById: "/api/Holiday/GetPackageById",
  filters: "/api/Holiday/GetFilters",
  holidayFilters: "/api/Holiday/GetHolidayFilters",
  destinations: "/api/Holiday/GetDestinations",
  search: "/api/Holiday/Search",
  searchHoliday: "/api/Holiday/SearchHoliday",
  holidaysBreaks: "/api/Holiday/HolidaysBreaks",
  downloadItinerary: "/api/Holiday/Downloaditinaryform",
  downloadHolidayItineraryPdf: "/api/Holiday/DownloadHolidayItinary",
  similarHolidays: "/api/Holiday/GetSimilerHolidays",
  homePageHeading: "/api/Holiday/GetHomePageHeading",
  homePageAdvertisement: "/api/Holiday/GetHomePageAdvertisement",
  listPageHeading: "/api/Holiday/GetListPageHeading",
  randomDestination: "/api/Holiday/GetSmartPopularDestination",
  travelType: "/api/Holiday/GetTravelType",
  interestType: "/api/Holiday/GetInterestType",
  experienceType: "/api/Holiday/GetExperienceType",
  smartHolidaysList: "/api/Holiday/GetSmartHolidaysList",
  submitSmartSearchEnquiry: "/api/Holiday/SubmiteSmartSearchEnquery",
};
